import BaseAPIService from 'src/services/base/base-api-service';
import ModelModel from 'src/model/model.model';
import DiagramModel from 'src/model/diagram.model';
import env from 'src/shared/env';

class ModelService extends BaseAPIService<ModelModel> {
  private basicURL: string = env.REACT_APP_BASE_API_URL;

  public buildModelEndpoint(modelId: string) {
    const decodeModeId=modelId.replace("*","%2A");
    return `${this.basicURL}navapp/v1/model/number/${decodeModeId}`;
  }

  public getModelData(
    modelId: string,
    activeAccount: string,
    manufacturer: string
  ) {
    const endpoint = this.buildModelEndpoint(modelId);
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint, { manufacturer })
        .then((model: ModelModel) => {
          resolve(model);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  public addDiagramOwnerToProducts(diagrams: DiagramModel[]) {
    return new Promise((resolve, reject) => {
      try {
        const newDiagrams = diagrams.slice();
        newDiagrams.map(diagram => {
          const diagramId = diagram.diagramId;
          diagram.products.map(product => {
            product.diagramOwner = diagramId;
            product.productDetailsState = 'pending';
            product.productDetails = null;
            product.isAvailable = false;
            product.productNumber =
              product.productNumber.split('  ').length === 2
                ? product.productNumber.split('  ')[1]
                : product.productNumber.split('  ')[0];
          });
        });
        resolve(newDiagrams);
      } catch (error) {
        reject(error);
      }
    });
  }
}

const modelServiceInstance = new ModelService(ModelModel);
Object.freeze(modelServiceInstance);

export default modelServiceInstance;
